define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = {
        disableButton: function (buttonElement, classesToRemove, classesToAdd) {
            var _a, _b;
            if (classesToRemove === void 0) { classesToRemove = []; }
            if (classesToAdd === void 0) { classesToAdd = []; }
            buttonElement === null || buttonElement === void 0 ? void 0 : buttonElement.setAttribute('disabled', 'disabled');
            buttonElement === null || buttonElement === void 0 ? void 0 : buttonElement.classList.remove('cursor-pointer');
            buttonElement === null || buttonElement === void 0 ? void 0 : buttonElement.classList.add('cursor-not-allowed');
            buttonElement === null || buttonElement === void 0 ? void 0 : buttonElement.removeAttribute('title');
            if (classesToRemove)
                buttonElement === null || buttonElement === void 0 ? void 0 : (_a = buttonElement.classList).remove.apply(_a, classesToRemove);
            if (classesToAdd)
                buttonElement === null || buttonElement === void 0 ? void 0 : (_b = buttonElement.classList).add.apply(_b, classesToAdd);
        },
        enableButton: function (buttonElement, title, classesToRemove, classesToAdd) {
            var _a, _b;
            if (title === void 0) { title = ""; }
            if (classesToRemove === void 0) { classesToRemove = []; }
            if (classesToAdd === void 0) { classesToAdd = []; }
            buttonElement === null || buttonElement === void 0 ? void 0 : buttonElement.removeAttribute('disabled');
            buttonElement === null || buttonElement === void 0 ? void 0 : buttonElement.classList.remove('cursor-not-allowed');
            buttonElement === null || buttonElement === void 0 ? void 0 : buttonElement.classList.add('cursor-pointer');
            if (title)
                buttonElement === null || buttonElement === void 0 ? void 0 : buttonElement.setAttribute('title', title);
            if (classesToRemove)
                buttonElement === null || buttonElement === void 0 ? void 0 : (_a = buttonElement.classList).remove.apply(_a, classesToRemove);
            if (classesToAdd)
                buttonElement === null || buttonElement === void 0 ? void 0 : (_b = buttonElement.classList).add.apply(_b, classesToAdd);
        },
        toggleDisableButton: function (buttonElement, disable) {
            if (disable) {
                buttonElement === null || buttonElement === void 0 ? void 0 : buttonElement.setAttribute('disabled', 'disabled');
                buttonElement === null || buttonElement === void 0 ? void 0 : buttonElement.classList.remove('cursor-pointer');
                buttonElement === null || buttonElement === void 0 ? void 0 : buttonElement.classList.add('cursor-not-allowed');
            }
            else {
                buttonElement === null || buttonElement === void 0 ? void 0 : buttonElement.removeAttribute('disabled');
                buttonElement === null || buttonElement === void 0 ? void 0 : buttonElement.classList.remove('cursor-not-allowed');
                buttonElement === null || buttonElement === void 0 ? void 0 : buttonElement.classList.add('cursor-pointer');
            }
        },
        redirectTo: function (url, timeout) {
            if (timeout === void 0) { timeout = 0; }
            if (timeout > 0) {
                setTimeout(function () { return window.location.href = url; }, timeout);
                return;
            }
            window.location.href = url;
        },
        getBaseUrl: function () {
            return document.getElementsByTagName('base')[0].href;
        },
        findGetParameter: function (parameterName) {
            var result = '', tmp = [];
            location.search
                .substring(1)
                .split("&")
                .forEach(function (item) {
                tmp = item.split("=");
                if (tmp[0] === parameterName)
                    result = decodeURIComponent(tmp[1]);
            });
            return result;
        },
    };
});
